import axios from "axios";
import { resolveApiBaseUrl } from "@/utils/apiBaseUrl";

const guestAxios = axios.create({
  baseURL: resolveApiBaseUrl(),
  withCredentials: true,
  headers: {
    Accept: "*/*",
  },
});

// Guest portal calls use server-side guest cookies. Session storage is only a
// navigation hint for returning to the room QR entry, not an auth source.
let guestAuthRedirecting = false;

const isGuestAuthCoreEndpoint = (url = "") =>
  url.includes("/api/guest-portal/me") ||
  url.includes("/api/guest-portal/heartbeat") ||
  url.includes("/api/guest-portal/billing/my-bill") ||
  url.includes("/api/guest-portal/profile") ||
  url.includes("/api/guest-portal/loyalty") ||
  url.includes("/api/guest-portal/memberships") ||
  url.includes("/api/guest-portal/coupons") ||
  url.includes("/api/guest-portal/amenities") ||
  url.includes("/api/guest-portal/hotel-services") ||
  url.includes("/api/GuestRequests/") ||
  url.includes("/api/Order/guest") ||
  url.includes("/api/Surveys/");

guestAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || "";
    const publicCode = sessionStorage.getItem("guestRoomPublicCode");
    const isRoomAccessEndpoint = requestUrl.includes("/api/guest-portal/room/");
    const shouldRedirectForGuestAuth =
      isGuestAuthCoreEndpoint(requestUrl) && !error?.config?.skipGuestAuthRedirect;

    if (
      (status === 401 || status === 403) &&
      !isRoomAccessEndpoint &&
      shouldRedirectForGuestAuth &&
      !guestAuthRedirecting
    ) {
      const target = publicCode ? `/guest/r/${publicCode}` : "/guest/expired";
      const current = `${window.location.pathname}${window.location.search}`;

      if (current !== target) {
        guestAuthRedirecting = true;
        window.location.assign(target);
      }
    }

    return Promise.reject(error);
  }
);

export default guestAxios;
